import { render } from "./icon-references.vue?vue&type=template&id=03158a3a"
import script from "./icon-references.vue?vue&type=script&lang=js"
export * from "./icon-references.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__